"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultReCaptcha = exports.defaultInputTextLimits = void 0;
const defaultInputTextLimits = exports.defaultInputTextLimits = {
    characterLimitForATextArea: 10000,
    characterLimitForATextBox: 500
};
const defaultReCaptcha = exports.defaultReCaptcha = {
    enabled: false,
    siteKey: ''
};
